import { useState, useEffect } from 'react';
import ContactService from '../../../services/contact_service';
import Loading from '../../../shared/Loading/Loading';

const RankingList = ({ logout }) => {
  const PAGE_SIZE = 5;

  const [users, setUsers] = useState([]);  
  const [loading, setLoading] = useState(true);

  useEffect(() => { (
    async () => {
      try {
        const user = await ContactService.getAll({
          pageSize: PAGE_SIZE,
          sort: {column: 'Score', direction: 'desc',},
          roles: ['Usuario']
        });
        if (logout(user)) return;
        const contacts = user.contacts || [];
        setUsers(contacts);
      } catch (e) {
        return;
      } finally {
        setLoading(false)
      }
    })();
  }, []);

  return (
    <div className="ranking-list-card bg-white shadow-md overflow-hidden rounded-lg">
      <div className="w-full overflow-hidden px-4 pb-3">
        {loading ? (
          <div className="flex justify-center py-10">
            <Loading size="28" colorBase='white' colorAccent='personalized' double={true} bold="8" />
          </div>
        ) : users.length === 0 ? (
          <div className="text-center text-sm text-gray-500 py-6">
            {'No hay usuarios disponibles'}
          </div>
        ) : (
          <table className="w-full divide-y divide-gray-200 table-fixed">
            <thead>
              <tr>
                <th className=" w-[50%] py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider md:w-[35%]">
                  <div className="inline-flex items-center">Top 5 usuarios</div>
                </th>
                <th className="w-[15%] py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="inline-flex items-center">Puntos</div>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {users.map((user) => {
                return (
                  <tr key={user.Id}>
                    <td className="py-1 whitespace-nowrap text-sm text-gray-500 font-semibold overflow-hidden truncate max-w-0">
                      {user?.PrincipalEmail}
                    </td>
                    <td className="px-2 py-1 whitespace-nowrap text-sm text-gray-800 font-bold">
                      {user?.Score}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default RankingList;
